import { render, staticRenderFns } from "./platformXbox.vue?vue&type=template&id=72b48024&"
import script from "./platformXbox.vue?vue&type=script&lang=js&"
export * from "./platformXbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports